import { isAfter } from 'date-fns';

/**
 * Transforms a admission booking part fulfillments into a refundable for admissions.
 */
export function transformRefundableAdmission(
    admission: ApiSchema['Admission'],
    apiBooking: ApiSchema['Booking'],
): RefundableAdmission {
    const passengers = apiBooking.passengers
        .filter(p => admission?.passengerIds.includes(p.id))
        .map(p => transformPassenger(p));
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === admission.id));

    const trips = apiBooking.trips
        ?.filter(t => admission.tripCoverage?.coveredTripIds?.includes(t.id))
        .map(t => transformBookedTrip(t))
        .filter(t => t !== undefined) ?? [];
    const trip = trips[0];

    const id = admission.id;
    const fulfillmentId = fulfillment?.id;
    const type = 'Admission';
    const status = admission.status;
    const name = passengers.map(p => `${p.firstName} ${p.lastName}`).join(', ');
    const birthDate = passengers.map(p => `*${formatMonthMediumYear(p.dateOfBirth)}`).join(', ');
    const summaryLine1 = formatMonthMediumYear(trip?.departureTime);
    const summaryLine2 = '';
    const detailLine1 = `${name} ${birthDate}`;
    const detailLine2 = '';
    const price = admission.price;
    const refundConditionDate = admission.afterSaleConditions?.find(c => c.condition === 'REFUND')?.validUntil;
    const refundDeadline = refundConditionDate ? zurichDate(refundConditionDate) : undefined;
    const isExpired = refundDeadline ? isAfter(zurichDate(), refundDeadline) : false;
    const isRefunded = admission.status === 'REFUNDED';
    const isRefundable = !!refundDeadline && admission.status === 'FULFILLED' && !isExpired;

    return {
        id,
        fulfillmentId,
        type,
        status,
        passengers,
        trip,
        trips,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        price,
        refundDeadline,
        isExpired,
        isRefunded,
        isRefundable,
    };
}
